import { gql } from '@apollo/client';
import { CART_SCHEMA } from './cart.api';
import client from '../../util/GraphqlClient';

const ADDON_SCHEMA = `
  code
  description
  offerType
  serviceGroup
  image {
    path
    altText
  }
  mobileImage {
    path
  }
  charges {
    code
    frequency
    name
    price
  }
  attributes {
    type
    value
    sortOrder
    icon
    description
  }
  displayName
  details
  orderIndex
  equipmentPrice {
    code
    discountedPrice
  }
  itemGroup
  
`;

const QUERIES = {
  GET_ADDONS: gql`
      query getAddOns(
        $offerTypeCode: String
        $serviceGroupCode: String
        $channel: String
        $equipmentCode: String
        $itemGroup: String
        $portIn: Boolean
      ) {
        getAddOns(
            offerTypeCode: $offerTypeCode
            serviceGroupCode: $serviceGroupCode
            channel: $channel
            equipmentCode : $equipmentCode
            itemGroup: $itemGroup
            portIn: $portIn
        ) {
          ${ADDON_SCHEMA}
        }
      }
    `,
  GET_COMPATIBLE_ADDONS: gql`
    query getCompatibleAddOns(
      $reference: String!
      $offerId: Int!
    ) {
      getCompatibleAddOns(
        reference: $reference
        offerId: $offerId
      ) {
        ${ADDON_SCHEMA}
      }
    }
  `,
  ADD_ADDONS: gql`
      mutation addAddOn(
        $reference: String!
        $catalogCode: String!
        $offerId: Int!
        $cartType: CartType!
      ) {
        addAddOn(
          reference: $reference
          catalogCode: $catalogCode
          offerId: $offerId
          cartType: $cartType
        ) {
          ${CART_SCHEMA}
        }
      }
    `,
  ADD_PREPAY_ADDONS: gql`
    mutation addPrepayAddon(
      $reference: String!
      $catalogCode: String!
      $offerId: Int!
      $cartType: CartType!
    ) {
      addPrepayAddon(
        reference: $reference
        catalogCode: $catalogCode
        offerId: $offerId
        cartType: $cartType
      ) {
        ${CART_SCHEMA}
      }
    }
  `,
  REMOVE_ADDONS: gql`
      mutation removeAddOn(
        $reference: String!
        $addOnId: Int!
        $offerId: Int!
        $cartType: CartType
      ) {
        removeAddOn(
          reference: $reference
          addOnId: $addOnId
          offerId: $offerId
          cartType: $cartType
        ) {
          ${CART_SCHEMA}
        }
      }
    `,
  ADD_EQUIPMENT_ADDONS: gql`
  mutation addEquipmentAddOn(
    $reference: String!
    $cartType: CartType
    $catalogCode: String!
    $cartOfferId: Int!
    $equipmentId: Int!
  ) {
    addEquipmentAddOn(
      cartType: $cartType
      reference: $reference
      catalogCode: $catalogCode
      cartOfferId: $cartOfferId
      equipmentId: $equipmentId
    ) {
      ${CART_SCHEMA}
    }
  }
  `,
  REMOVE_EQUIPMENT_ADDONS: gql`
  mutation removeEquipmentAddOn(
    $reference: String!
    $cartType: CartType
    $addOnId: Int!
    $offerId: Int!
    $equipmentId: Int!
  ) {
    removeEquipmentAddOn(
      cartType: $cartType
      reference: $reference
      addOnId: $addOnId
      offerId: $offerId
      equipmentId: $equipmentId
    ) {
      ${CART_SCHEMA}
    }
  }
  `,
  GET_MOBILE_SECURITY_ADDONS: gql`
      query getAddOns(
        $offerTypeCode: String
        $serviceGroupCode: String
        $channel: String
        $codes: [String]
      ) {
        getAddOns(
            offerTypeCode: $offerTypeCode
            serviceGroupCode: $serviceGroupCode
            channel: $channel
            codes: $codes
        ) {
          ${ADDON_SCHEMA}
        }
      }
    `,
};

// to get Addons
export const getAddOns = async ({ variables = {} }) => {
  const { data } = await client.query({
    query: QUERIES.GET_ADDONS,
    variables,
  });
  const sortData = [...data.getAddOns].sort((a, b) => Number(a.orderIndex) - Number(b.orderIndex));
  return sortData;
};

// to get compatible addons
export const getCompatibleAddOns = async ({ variables = {} }) => {
  const { data } = await client.query({
    query: QUERIES.GET_COMPATIBLE_ADDONS,
    variables,
  });
  return data.getCompatibleAddOns;
};

// to add Addons
export const addAddOns = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.ADD_ADDONS,
    variables,
  });
  return data.addAddOn;
};

// to add Addons
export const addPrepayAddOns = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.ADD_PREPAY_ADDONS,
    variables,
  });
  return data.addPrepayAddon;
};
// to remove Addons
export const removeAddOns = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.REMOVE_ADDONS,
    variables,
  });
  return data.removeAddOn;
};
// to add equipment Addons
export const addEquipmentAddOn = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.ADD_EQUIPMENT_ADDONS,
    variables,
  });
  return data.addEquipmentAddOn;
};
// to remove equipment Addons
export const removeEquipmentAddOn = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.REMOVE_EQUIPMENT_ADDONS,
    variables,
  });
  return data.removeEquipmentAddOn;
};
// to get mobile security addon
export const getMobileSecurityAddOn = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_MOBILE_SECURITY_ADDONS,
    variables,
  });
  return data.getAddOns;
};
